import { createSelector } from 'reselect';

import { isFullTimeCourseSelector, isPartTimeCourseSelector } from '../../../reducers/selectors';

const workExperienceSelector = state => state.builder.ui.workExperience;

const workExperienceLevelSelector = createSelector(
  workExperienceSelector,
  isFullTimeCourseSelector,
  isPartTimeCourseSelector,
  (workExperience, isFullTimeCourse, isPartTimeCourse) => {
    let experienceLevel = 'noExperienceFullTime';

    if (isPartTimeCourse) experienceLevel = 'partTimeCourse';
    const { monthsExperience = '0', yearsExperience = '0' } = workExperience || {};
    const totalExperience =
      parseInt(yearsExperience || '0', 10) * 12 + parseInt(monthsExperience || '0', 10);
    if (totalExperience > 0 && isFullTimeCourse) experienceLevel = 'experiencedFullTime';

    return experienceLevel;
  },
);

export default workExperienceLevelSelector;
